import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const GSTRegistration = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        GST Registration
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        GST represents a landmark tax reform in India, simplifying the tax
        landscape by consolidating multiple taxes into a unified system,
        enhancing business ease, and expanding the taxpayer base to include
        numerous small enterprises.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Registration Mandate */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Registration Mandate
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Under the new GST framework, all entities engaged in the purchase or
            sale of goods, provision of services, or both must register for a
            GSTIN once their annual turnover exceeds specified thresholds or
            when starting a new venture projected to surpass these limits.
          </p>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Registration is compulsory for entities with an aggregate turnover
            exceeding Rs. 20 lakhs for services (Rs. 10 lakhs in special category
            states) or Rs. 40 lakhs for goods. Inter-state suppliers, e-commerce
            sellers, casual taxable persons, and those opting for voluntary
            registration are also required to register, regardless of turnover
            in some cases.
          </p>

          {/* Registration Categories */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Registration Categories
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ul
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              <strong>Normal Scheme:</strong> For resident taxpayers with no
              deposit requirement and indefinite validity.
            </li>
            <li>
              <strong>Non-Resident Taxable Person:</strong> For foreign entities
              supplying to India, valid for three months.
            </li>
            <li>
              <strong>Casual Taxable Person:</strong> For seasonal or temporary
              businesses, requiring a deposit equal to GST liability, valid for
              three months.
            </li>
            <li>
              <strong>Composition Scheme:</strong> For entities with turnover
              below Rs. 1.5 crores, offering a flat GST rate without input tax
              credit.
            </li>
          </ul>

          {/* Application Process */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Application Process
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The registration process requires the following documents:
          </p>
          <ol
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              <strong>PAN Card:</strong> Mandatory for the business entity as GST
              is linked to it.
            </li>
            <li>
              <strong>Identity Proof:</strong> PAN, passport, driving license,
              Aadhaar, or voter ID, along with promoter photographs.
            </li>
            <li>
              <strong>Address Proof:</strong> Passport, driving license, Aadhaar,
              voter ID, or ration card for promoters.
            </li>
            <li>
              <strong>Business Registration:</strong> Incorporation certificate
              for LLPs/companies, partnership deed for firms, or registration
              certificate for societies/trusts (not required for
              proprietorships).
            </li>
            <li>
              <strong>Business Location Proof:</strong> Ownership documents (e.g.,
              property tax receipt), rental agreement with lessor proof, SEZ
              certificates, or consent letter for shared premises.
            </li>
            <li>
              <strong>Bank Account Proof:</strong> Scanned first page of
              passbook, bank statement, or cancelled cheque with account
              details.
            </li>
          </ol>

          {/* Supporting Evidence */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Supporting Evidence
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Applicants must ensure all documents are current, with residence
            proofs like utility bills not older than two months. Foreign
            nationals require apostilled or notarized passports.
          </p>

          {/* Closing Observations */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Closing Observations
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            GST registration is a critical step for businesses to comply with
            India’s tax reforms, ensuring legal operation and access to a
            simplified tax system. Proper documentation and understanding of
            category-specific requirements are essential for a smooth process.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GSTRegistration;